import React from "react"
import InfoSectionDesktop from "./InfoSectionDesktop"
import InfoSectionMobile from "./InfoSectionMobile"
import { useMediaQuery } from "react-responsive"
import { InfoSectionProps } from "@/app/interface/components"

const InfoSection: React.FC<InfoSectionProps> = ({ href="/contato", title, text }) => {
    const isDesktop = useMediaQuery({ minWidth: 1140 })
    
    return (
        <>
            {
                isDesktop ? (
                    <InfoSectionDesktop href={href} title={title} text={text} />
                ) : (
                    <InfoSectionMobile href={href} title={title} text={text} />
                )
            }
        </>
    )
}

export default React.memo(InfoSection)